const useYandexRotor = (isLoaded: boolean) => {
    if (isLoaded) {
        setTimeout(() => {
            if (window.YandexRotorSettings) window.YandexRotorSettings.IsLoaded = true;
        }, 200);
    }
}

export default useYandexRotor;
